export default __webpack_public_path__ + "static/media/rf-ico.39010e49.svg";